(function () {
  "use strict";
  function S(s) {
    const e = {};
    for (const t of s.zones) e[t.id] = t.defaultColor;
    return { configVersion: s.configVersion, size: s.sizes[0], zones: e };
  }
  function z(s, e) {
    return { ...s, size: e };
  }
  const L = "KR1.",
    T = "KR2.",
    x = new TextEncoder();
  new TextDecoder();
  function y(s) {
    return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  function R(s) {
    const e = [];
    for (let n = 0; n < s.length; n += 8192)
      e.push(String.fromCharCode(...s.subarray(n, n + 8192)));
    return e.join("");
  }
  function N(s) {
    return y(R(s));
  }
  function P() {
    return typeof CompressionStream < "u";
  }
  async function U(s) {
    const e = new CompressionStream("deflate-raw"),
      t = e.writable.getWriter();
    (t.write(s), t.close());
    const n = [],
      r = e.readable.getReader();
    for (;;) {
      const { done: i, value: l } = await r.read();
      if (i) break;
      n.push(l);
    }
    let o = 0;
    for (const i of n) o += i.length;
    const a = new Uint8Array(o);
    let c = 0;
    for (const i of n) (a.set(i, c), (c += i.length));
    return a;
  }
  async function w(s) {
    const e = JSON.stringify(s);
    if (P()) {
      const t = await U(x.encode(e));
      return `${T}${N(t)}`;
    }
    return `${L}${y(e)}`;
  }
  function q(s, root = document) {
    const e = root.querySelector(s);
    try {
      return e ? JSON.parse(e.textContent) : {};
    } catch {
      return {};
    }
  }
  function completeProductValues(payload) {
    const values = payload?.values || payload || {};
    return values && values.js && values.js.configurator && values.js.stock && values.js.cart ? values : null;
  }
  function runtimeValues(payload, root) {
    const values = completeProductValues(payload) || {};
    const runtime = values.js || values;
    const leadTime = root?.dataset?.leadTime;
    if (leadTime && runtime.configurator?.lead_time) {
      return {
        ...runtime,
        configurator: {
          ...runtime.configurator,
          lead_time: F(runtime.configurator.lead_time, { lead_time: leadTime }),
        },
      };
    }
    return runtime;
  }
  async function loadProductTranslations() {
    const script = document.querySelector("[data-kr-translations]");
    const root = document.querySelector("[data-kr-configurator-root]") || document.querySelector("[data-kr-stock-root]");
    const inlinePayload = q("[data-kr-translations]");
    const assetUrl = root?.dataset?.localeMapUrl || script?.dataset?.krLocaleMap;
    if (assetUrl && typeof fetch === "function") {
      try {
        const response = await fetch(assetUrl, { credentials: "same-origin" });
        if (response.ok) {
          const assetPayload = await response.json();
          if (completeProductValues(assetPayload)) return runtimeValues(assetPayload, root);
        }
      } catch {}
    }
    return runtimeValues(inlinePayload, root);
  }
  function F(s, e) {
    return String(s).replace(/\{\{\s*(\w+)\s*\}\}/g, (t, n) => e[n] ?? t);
  }
  function G(s, e) {
    const t = e.configurator || {};
    return {
      ...s,
      zones: s.zones.map((n) => ({
        ...n,
        nativeLabel: n.label,
        label: (t.zones || {})[n.id] || n.label,
        colors: n.colors.map((o) => ({
          ...o,
          nativeLabel: o.label,
          label: (t.colors || {})[o.id] || o.label,
        })),
      })),
    };
  }
  const A = new Set([119, 129, 139, 149, 159, 169, 179, 189]);
  function I(s) {
    const e = s;
    if (e.brand !== "JYRO" || e.model !== "Kraken")
      throw new Error(
        `Invalid config: expected JYRO Kraken, got ${e.brand} ${e.model}`,
      );
    if (typeof e.configVersion != "string" || e.configVersion.length === 0)
      throw new Error("Invalid config: missing configVersion");
    const t = e.sizes;
    if (!Array.isArray(t) || t.length === 0)
      throw new Error("Invalid config: sizes must be a non-empty array");
    for (const o of t)
      if (!A.has(o)) throw new Error(`Invalid config: unknown size ${o}`);
    const n = e.zones;
    if (!Array.isArray(n) || n.length === 0)
      throw new Error("Invalid config: zones must be a non-empty array");
    const r = e.priceSignatures;
    if (!Array.isArray(r) || r.length === 0)
      throw new Error(
        "Invalid config: priceSignatures must be a non-empty array",
      );
    const signatureKeys = new Set();
    for (const signature of r) {
      if (!A.has(signature.size)) throw new Error(`Invalid variant size ${signature.size}`);
      if (!new Set(["low-bulk", "zp"]).has(signature.model))
        throw new Error(`Invalid variant model ${signature.model}`);
      const key = `${signature.model}/${signature.size}/${signature.lineType}`;
      if (signatureKeys.has(key)) throw new Error(`Duplicate variant signature ${key}`);
      signatureKeys.add(key);
    }
    for (const size of t) {
      const required = [
        `low-bulk/${size}/Standard`,
        `zp/${size}/Vectran 400`,
        `zp/${size}/Vectran 500`,
        `zp/${size}/Vectran 750`,
        `zp/${size}/Stock canopy`,
      ];
      for (const key of required)
        if (!signatureKeys.has(key)) throw new Error(`Missing variant signature ${key}`);
    }
    return e;
  }
  function C(s, e, t, model = "low-bulk") {
    const n = s.priceSignatures.find(
      (r) => r.size === e && r.lineType === t && r.model === model,
    );
    if (!n) {
      const fallbackLine = model === "zp" ? s.defaultLinesByModel?.zp : s.defaultLines;
      const r = s.priceSignatures.find(
        (o) => o.size === e && o.lineType === fallbackLine && o.model === model,
      );
      if (!r) throw new Error(`No variant for ${model} / ${e} / ${t}`);
      return r.variantId;
    }
    return n.variantId;
  }
  function m(s, e, model = "low-bulk") {
    const t = s.priceSignatures.find((n) => n.size === e && n.model === model);
    if (!t) throw new Error(`No price signature for ${model} / ${e}`);
    return t.priceEur;
  }
  function j(s, e, t) {
    const n = s.zones.find((o) => o.id === e);
    if (!n) return t;
    const r = n.colors.find((o) => o.id === t);
    return r ? r.nativeLabel || r.label : t;
  }
  const NATIVE_CART = {
    custom_design: "Custom Design",
    design_preview: "_Design Preview",
    design_link: "_Design Link",
    colors: "Colors",
    status: "Status",
    ready: "Ready",
    in_production: "In Production",
    stock_source: "JYRO Stock",
    fabric: "Fabric",
    model: "Model",
    line_type: "Line Type",
    stock_reference: "Stock Reference",
    top_skin: "Top Skin",
  };
  function B(s, e, t, n, r) {
    const model = n.fabricId || "low-bulk",
      o = C(s, e.size, t, model),
      a = {
        _source: NATIVE_CART.custom_design,
        [NATIVE_CART.fabric]: n.nativeFabricLabel || "Low Bulk",
        [NATIVE_CART.line_type]: t,
      };
    for (const i of s.zones) {
      const c = e.zones[i.id];
      c && (a[i.nativeLabel || i.label] = j(s, i.id, c));
    }
    return (
      n.previewUrl && (a[NATIVE_CART.design_preview] = n.previewUrl),
      n.designLink && (a[NATIVE_CART.design_link] = n.designLink),
      { items: [{ id: o, quantity: 1, properties: a }] }
    );
  }
  function O(s, e, t) {
    const model = /\bZP\b/i.test(e.model || "") ? "zp" : "low-bulk",
      lineType = model === "zp" ? "Stock canopy" : s.defaultLines,
      r = C(s, e.size, lineType, model),
      o = {
        [NATIVE_CART.model]: e.model,
        [NATIVE_CART.colors]: e.colors,
        [NATIVE_CART.status]: e.status === "ready" ? NATIVE_CART.ready : NATIVE_CART.in_production,
        [NATIVE_CART.stock_reference]: e.sourceUrl || e.id,
        _source: NATIVE_CART.stock_source,
      };
    return { items: [{ id: r, quantity: 1, properties: o }] };
  }
  const f = {
      normal: {
        position: [-17.287, 33.031, 39.847],
        target: [14.407, 30.922, 0],
        fov: 28,
      },
      top: {
        position: [12.407, 114.292, 0.008],
        target: [9.407, 31.922, 0],
        fov: 21,
      },
      bottom: {
        position: [6.407, -50.448, 0.008],
        target: [9.407, 31.922, 0],
        fov: 22,
      },
      back: {
        position: [86.963, 90.478, 37.556],
        target: [14.407, 34.922, 4],
        fov: 17,
      },
    },
    g = class g {
      constructor(e) {
        ((this.appUrl = e || g.APP_URL),
          (this.iframe = null),
          (this.state = "unknown"),
          (this.listeners = new Map()),
          (this.readyResolve = null),
          (this.registered = !1),
          (this.handleMessage = (e) => {
            var a, c;
            if (!((a = e.origin) != null && a.includes("emersya.com"))) return;
            const t = e.data;
            if (!t || typeof t != "object") return;
            const n = t.action;
            if (n === "onStateChange") {
              const i = t.state;
              (i == null ? void 0 : i.viewerState) === "loaded"
                ? ((this.state = "loaded"),
                  (this.registered = !0),
                  (c = this.readyResolve) == null || c.call(this),
                  (this.readyResolve = null))
                : (i == null ? void 0 : i.viewerState) === "loading" &&
                  (this.state = "loading");
            }
            const r = this.listeners.get(n);
            if (r) for (const i of r) i(t);
            const o = this.listeners.get("*");
            if (o) for (const i of o) i(t);
          }),
          (this.readyPromise = new Promise((e) => {
            this.readyResolve = e;
          })),
          window.addEventListener("message", this.handleMessage));
      }
      embed(e) {
        return (
          (this.iframe = document.createElement("iframe")),
          (this.iframe.src = this.appUrl),
          (this.iframe.className = "kr-emersya-iframe"),
          (this.iframe.allow = "autoplay; fullscreen; xr-spatial-tracking"),
          (this.iframe.allowFullscreen = !0),
          (this.iframe.referrerPolicy = "no-referrer"),
          this.iframe.setAttribute("loading", "lazy"),
          e.appendChild(this.iframe),
          this.iframe.addEventListener("load", () => {
            setTimeout(() => this.register(), 1500);
          }),
          this.readyPromise
        );
      }
      register() {
        this.registered || this.send({ action: "registerCallback" });
      }
      send(e) {
        var t;
        (t = this.iframe) != null &&
          t.contentWindow &&
          this.iframe.contentWindow.postMessage(e, "*");
      }
      on(e, t) {
        (this.listeners.has(e) || this.listeners.set(e, new Set()),
          this.listeners.get(e).add(t));
      }
      off(e, t) {
        var n;
        (n = this.listeners.get(e)) == null || n.delete(t);
      }
      getState() {
        return this.state;
      }
      isReady() {
        return this.state === "loaded";
      }
      getCurrentConfiguration() {
        return new Promise((e) => {
          const t = (n) => {
            this.off("onGetCurrentConfiguration", t);
            const r = n.configuration;
            if (typeof r == "string")
              try {
                e(JSON.parse(r));
              } catch {
                e({});
              }
            else e(typeof r == "object" && r !== null ? r : {});
          };
          (this.on("onGetCurrentConfiguration", t),
            this.send({ action: "getCurrentConfiguration" }));
        });
      }
      setConfiguration(e) {
        this.send({ action: "setDefaultConfiguration", configuration: e });
      }
      setCamera(e) {
        this.send({
          action: "setCamera",
          position: e.position,
          target: e.target,
          up: e.up ?? [0, 1, 0],
          transitionTime: e.transitionTime ?? 800,
          fov: e.fov ?? 28,
          unstoppable: e.unstoppable ?? !1,
        });
      }
      getScreenshot(e = 512, t = 280) {
        return new Promise((n, r) => {
          const o = setTimeout(() => {
              (this.off("onScreenshot", a), r(new Error("Screenshot timeout")));
            }, 1e4),
            a = (c) => {
              (clearTimeout(o), this.off("onScreenshot", a));
              const i = c.screenshot;
              i ? n(i) : r(new Error("No screenshot data"));
            };
          (this.on("onScreenshot", a),
            this.send({
              action: "getScreenshot",
              width: e,
              height: t,
              takebackground: !0,
            }));
        });
      }
      async getMultiViewScreenshots() {
        const e = ["normal", "top", "bottom", "back"],
          t = [];
        for (const n of e) {
          const r = f[n];
          (this.setCamera({
            position: r.position,
            target: r.target,
            fov: r.fov,
            transitionTime: 600,
            unstoppable: !0,
          }),
            await new Promise((o) => setTimeout(o, 800)));
          try {
            const o = await this.getScreenshot(512, 280);
            t.push({ dataUrl: o, view: n });
          } catch {}
        }
        return (
          this.setCamera({
            position: f.normal.position,
            target: f.normal.target,
            fov: f.normal.fov,
            transitionTime: 600,
          }),
          t
        );
      }
      destroy() {
        var e;
        (window.removeEventListener("message", this.handleMessage),
          this.listeners.clear(),
          (e = this.iframe) != null &&
            e.parentElement &&
            this.iframe.parentElement.removeChild(this.iframe),
          (this.iframe = null));
      }
    };
  g.APP_URL = "https://emersya.com/app/U5GUO3XKIE?model=kraken";
  let k = g;
  const $ = {
    jyro_configurator_started: "ViewContent",
    jyro_configuration_saved: "Lead",
    jyro_add_to_cart_clicked: "AddToCart",
    jyro_custom_added_to_cart: "AddToCart",
    jyro_stock_added_to_cart: "AddToCart",
  };
  function d(s, e = {}) {
    if (
      ((window.dataLayer ?? (window.dataLayer = [])).push({ ...e, event: s }),
      typeof window.fbq == "function")
    ) {
      const n = $[s];
      n ? window.fbq("track", n, e) : window.fbq("trackCustom", s, e);
    }
  }
  const h = class h {
    constructor(e, t) {
      ((this.selectedLines = "Standard"),
        (this.root = e),
        (this.options = t),
        (this.state = S(t.config)),
        (this.fabricChoices = [
          {
            id: "low-bulk",
            label: t.translations?.configurator?.fabrics?.["low-bulk"] || "Low Bulk",
            nativeLabel: "Low Bulk",
            url: "https://emersya.com/app/U5GUO3XKIE?model=kraken",
          },
          {
            id: "zp",
            label: t.translations?.configurator?.fabrics?.zp || "ZP",
            nativeLabel: "ZP",
            url: "https://emersya.com/app/CXH5LTHRBR?model=kraken-j-zp",
          },
        ]),
        (this.activeFabric = "low-bulk"),
        (this.bridge = new k(this.getActiveFabric().url)),
        t.config.defaultLines && (this.selectedLines = t.config.defaultLines));
    }
    getActiveFabric() {
      return (
        this.fabricChoices.find((e) => e.id === this.activeFabric) ||
        this.fabricChoices[0]
      );
    }
    setFabric(e) {
      if (e === this.activeFabric) return;
      this.activeFabric = e;
      this.selectedLines = e === "zp" ? this.options.config.defaultLinesByModel.zp : this.options.config.defaultLines;
      this.bridge.destroy();
      this.bridge = new k(this.getActiveFabric().url);
      (this.render(),
        d("jyro_configurator_fabric_selected", {
          fabric: this.getActiveFabric().label,
        }));
    }
    async mount() {
      (this.render(),
        d("jyro_configurator_started", {
          model: "Kraken",
          configVersion: this.options.config.configVersion,
        }));
    }
    render() {
      ((this.root.innerHTML = ""), (this.root.className = "kr-configurator"));
      const e = document.createElement("div");
      ((e.className = "kr-configurator__header"),
        (e.innerHTML = `
      <h2 class="kr-configurator__title">${u(this.options.translations.configurator.title)}</h2>
      <p class="kr-configurator__subtitle">${u(this.options.translations.configurator.subtitle)}</p>
    `));
      const a = document.createElement("div");
      ((a.className = "kr-configurator__tabs"),
        a.setAttribute("role", "tablist"),
        a.setAttribute("aria-label", this.options.translations.configurator.choose_fabric));
      for (const c of this.fabricChoices) {
        const i = document.createElement("button");
        ((i.type = "button"),
          (i.className = "kr-configurator__tab"),
          c.id === this.activeFabric &&
            i.classList.add("kr-configurator__tab--active"),
          i.setAttribute("role", "tab"),
          i.setAttribute(
            "aria-selected",
            c.id === this.activeFabric ? "true" : "false",
          ),
          (i.textContent = c.label),
          i.addEventListener("click", () => this.setFabric(c.id)),
          a.appendChild(i));
      }
      (e.appendChild(a), this.root.appendChild(e));
      const t = document.createElement("div");
      t.className = "kr-configurator__viewer";
      const n = document.createElement("div");
      ((n.className = "kr-configurator__loading"),
        (n.innerHTML = `
      <div class="kr-configurator__loading-spinner"></div>
      <p>${u(this.options.translations.configurator.loading)}</p>
    `),
        t.appendChild(n),
        this.root.appendChild(t),
        this.bridge.embed(t).then(() => {
          n.style.display = "none";
        }),
        setTimeout(() => {
          n.style.display = "none";
        }, 4500));
      const r = document.createElement("div");
      r.className = "kr-configurator__options-bar";
      r.appendChild(this.buildSizeSelector());
      const lineSelector = this.buildLineSelector();
      lineSelector && r.appendChild(lineSelector);
      this.root.appendChild(r);
      this.root.appendChild(this.buildBottomBar());
    }
    buildSizeSelector() {
      const e = document.createElement("fieldset");
      ((e.className = "kr-configurator__fieldset"),
        (e.innerHTML =
          `<legend class="kr-configurator__legend">${u(this.options.translations.configurator.size)}</legend>`));
      const t = document.createElement("div");
      t.className = "kr-configurator__size-pills";
      for (const n of this.options.config.sizes) {
        const r = document.createElement("button");
        ((r.className = "kr-configurator__size-pill"),
          this.state.size === n &&
            r.classList.add("kr-configurator__size-pill--active"),
          (r.textContent = String(n)),
          (r.dataset.krSize = String(n)),
          (r.type = "button"),
          r.addEventListener("click", () => {
            ((this.state = z(this.state, n)),
              d("jyro_size_selected", { size: n }),
              this.updatePriceDisplay(),
              this.refreshSizePills());
          }),
          t.appendChild(r));
      }
      return (e.appendChild(t), e);
    }
    buildLineSelector() {
      if (this.activeFabric !== "zp") return null;
      const options = this.options.config.lineOptionsByModel?.zp || [];
      if (!options.length) return null;
      const fieldset = document.createElement("fieldset");
      fieldset.className = "kr-configurator__fieldset";
      fieldset.innerHTML = `<legend class="kr-configurator__legend">${u(this.options.translations.configurator.line_type || "LINE TYPE")}</legend>`;
      const pills = document.createElement("div");
      pills.className = "kr-configurator__size-pills";
      for (const lineType of options) {
        const button = document.createElement("button");
        button.className = "kr-configurator__size-pill";
        button.classList.toggle("kr-configurator__size-pill--active", this.selectedLines === lineType);
        button.textContent = lineType;
        button.type = "button";
        button.addEventListener("click", () => {
          this.selectedLines = lineType;
          d("jyro_line_type_selected", { model: "zp", lineType });
          pills.querySelectorAll(".kr-configurator__size-pill").forEach((pill) => {
            pill.classList.toggle("kr-configurator__size-pill--active", pill === button);
          });
        });
        pills.appendChild(button);
      }
      fieldset.appendChild(pills);
      return fieldset;
    }
    refreshSizePills() {
      this.root.querySelectorAll("[data-kr-size]").forEach((t) => {
        const n = Number(t.dataset.krSize);
        t.classList.toggle(
          "kr-configurator__size-pill--active",
          n === this.state.size,
        );
      });
    }
    buildBottomBar() {
      const e = document.createElement("div");
      e.className = "kr-configurator__bottom-bar";
      const t = document.createElement("div");
      t.className = "kr-configurator__price-wrap";
      const n = document.createElement("span");
      ((n.className = "kr-configurator__price-label"),
        (n.textContent = this.options.translations.configurator.custom_order),
        t.appendChild(n));
      const r = document.createElement("span");
      ((r.className = "kr-configurator__price"),
        (r.id = "kr-price-display"),
        (r.textContent = this.formatPrice()),
        t.appendChild(r));
      const o = document.createElement("span");
      ((o.className = "kr-configurator__lead-time"),
        (o.textContent = this.options.translations.configurator.lead_time),
        t.appendChild(o),
        e.appendChild(t));
      const a = document.createElement("div");
      a.className = "kr-configurator__actions";
      const c = document.createElement("button");
      ((c.className = "kr-configurator__btn kr-configurator__btn--outline"),
        (c.textContent = this.options.translations.configurator.save_design),
        (c.type = "button"),
        c.addEventListener("click", () => this.handleSave()),
        a.appendChild(c));
      const i = document.createElement("button");
      return (
        (i.className = "kr-configurator__btn kr-configurator__btn--solid"),
        (i.textContent = this.options.translations.configurator.add_to_cart),
        (i.type = "button"),
        i.addEventListener("click", () => this.handleAddToCart()),
        a.appendChild(i),
        e.appendChild(a),
        e
      );
    }
    formatPrice() {
      const e = m(this.options.config, this.state.size, this.activeFabric);
      return new Intl.NumberFormat(this.options.locale || "en", {
        style: "currency",
        currency: this.options.currency || "EUR",
      }).format(e);
    }
    updatePriceDisplay() {
      const e = document.getElementById("kr-price-display");
      e && (e.textContent = this.formatPrice());
    }
    async captureDesign() {
      let e = {},
        t = null;
      if (this.bridge.isReady()) {
        try {
          e = await this.bridge.getCurrentConfiguration();
        } catch {}
        try {
          t = await this.bridge.getScreenshot(512, 280);
        } catch {}
      }
      return { colorConfig: e, screenshotDataUrl: t };
    }
    async handleSave() {
      const { colorConfig: e } = await this.captureDesign(),
        t = { ...this.state, zones: e },
        n = await w(t),
        r = new URL(this.options.productUrl, window.location.origin);
      (r.searchParams.set("krc", n),
        window.history.replaceState(null, "", r.toString()));
      let o = r.toString();
      try {
        o = await this.shortenUrl(r.toString());
      } catch {}
      (d("jyro_configuration_saved", { size: this.state.size, configCode: n }),
        this.showSharePanel(o));
    }
    showSharePanel(e) {
      const t = this.root.querySelector(".kr-configurator__share-panel");
      t && t.remove();
      const n = document.createElement("div");
      n.className = "kr-configurator__share-panel";
      const r = document.createElement("p");
      ((r.className = "kr-configurator__share-heading"),
        (r.textContent = this.options.translations.configurator.saved),
        n.appendChild(r));
      const o = document.createElement("div");
      o.className = "kr-configurator__share-url-wrap";
      const a = document.createElement("input");
      ((a.type = "text"),
        (a.readOnly = !0),
        (a.value = e),
        (a.className = "kr-configurator__share-url"),
        o.appendChild(a),
        n.appendChild(o));
      const c = document.createElement("div");
      c.className = "kr-configurator__share-btns";
      const i = document.createElement("button");
      ((i.type = "button"),
        (i.className =
          "kr-configurator__btn kr-configurator__btn--outline kr-configurator__share-copy"),
        (i.textContent = this.options.translations.configurator.copy_link),
        i.addEventListener("click", async () => {
          try {
            (await navigator.clipboard.writeText(e),
              (i.textContent = this.options.translations.configurator.copied),
              i.classList.add("kr-configurator__btn--success"),
              setTimeout(() => {
                ((i.textContent = this.options.translations.configurator.copy_link),
                  i.classList.remove("kr-configurator__btn--success"));
              }, 2e3));
          } catch {
            a.select();
          }
        }),
        c.appendChild(i));
      const l = document.createElement("a");
      ((l.className = "kr-configurator__btn kr-configurator__btn--whatsapp"),
        (l.href = `https://wa.me/?text=${encodeURIComponent(F(this.options.translations.configurator.whatsapp_message, { design_url: e }))}`),
        (l.target = "_blank"),
        (l.rel = "noopener"),
        (l.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>'),
        l.append(document.createTextNode(this.options.translations.configurator.whatsapp)),
        c.appendChild(l),
        n.appendChild(c));
      const p = document.createElement("button");
      ((p.type = "button"),
        (p.className = "kr-configurator__share-close"),
        (p.textContent = this.options.translations.configurator.close),
        p.addEventListener("click", () => n.remove()),
        n.appendChild(p));
      const E = this.root.querySelector(".kr-configurator__bottom-bar");
      E ? E.after(n) : this.root.appendChild(n);
    }
    async handleAddToCart() {
      d("jyro_add_to_cart_clicked", { size: this.state.size });
      const { colorConfig: e, screenshotDataUrl: t } =
        await this.captureDesign();
      let n, r;
      if (t)
        try {
          const a = await this.dataUrlToBlob(t);
          n = await this.uploadPreview(a);
        } catch {}
      try {
        const a = { ...this.state, zones: e },
          c = await w(a);
        r = await this.shortenUrl(`${this.options.productUrl}?krc=${c}`);
      } catch {}
      const o = B(this.options.config, this.state, this.selectedLines, {
        previewUrl: n,
        designLink: r,
        fabricLabel: this.getActiveFabric().label,
        nativeFabricLabel: this.getActiveFabric().nativeLabel,
        fabricId: this.activeFabric,
      }, this.options.translations);
      if (o.items.length > 0 && Object.keys(e).length > 0) {
        const a = [];
        for (const [c, i] of Object.entries(e))
          (c.startsWith("canopy_l") ||
            c.startsWith("canopy_n") ||
            c.match(/^canopy_\d/)) &&
            (a.includes(i) || a.push(i));
        a.length > 0 && (o.items[0].properties[NATIVE_CART.top_skin] = a.join(", "));
      }
      (d("jyro_custom_added_to_cart", {
        size: this.state.size,
        value: m(this.options.config, this.state.size, this.activeFabric),
        currency: this.options.currency,
      }),
        this.options.onAddToCart(o));
    }
    dataUrlToBlob(e) {
      return fetch(e).then((t) => t.blob());
    }
    async uploadPreview(e) {
      const t = await fetch(h.SHARED_WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filename: "preview.png",
          folder: "jyro-kraken/previews",
        }),
      });
      if (!t.ok) throw new Error("Failed to get upload signature");
      const { url: n, fields: r } = await t.json(),
        o = new FormData();
      for (const [i, l] of Object.entries(r)) o.append(i, l);
      o.append("file", e, "preview.png");
      const a = await fetch(n, { method: "POST", body: o });
      if (!a.ok) throw new Error("Upload failed");
      return (await a.json()).secure_url;
    }
    async shortenUrl(e) {
      const t = await fetch(`${h.SHARED_WORKER_URL}/shorten`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: e, prefix: "jyro" }),
      });
      if (!t.ok) throw new Error("URL shortening failed");
      return (await t.json()).shortURL;
    }
  };
  h.SHARED_WORKER_URL = "https://tfx-photo-upload.young-sky-a2c1.workers.dev";
  let _ = h;
  function D(s) {
    return s
      .replace(/&#8211;/g, "–")
      .replace(/&#8212;/g, "—")
      .replace(/&#38;/g, "&")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, " ");
  }
  function u(s) {
    return D(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  class H {
    constructor(e, t) {
      ((this.canopies = []),
        (this.activeFilter = null),
        (this.activeModel = null),
        (this.expanded = !1),
        (this.root = e),
        (this.options = t));
    }
    async mount() {
      this.root.innerHTML = `<p class="kr-stock__loading">${u(this.options.translations.stock.loading)}</p>`;
      try {
        const endpoints = ["kraken-low-bulk", "kraken-zp"];
        const responses = await Promise.all(
          endpoints.map((slug) => fetch(`${this.options.apiBaseUrl}/api/stock/${slug}`)),
        );
        const failed = responses.find((response) => !response.ok);
        if (failed) throw new Error(`Stock API ${failed.status}`);
        const payloads = await Promise.all(responses.map((response) => response.json()));
        this.canopies = payloads
          .flatMap((payload) => payload.canopies || [])
          .sort((a, b) => a.size - b.size || a.model.localeCompare(b.model));
        d("jyro_stock_grid_viewed", {
          count: this.canopies.length,
          lowBulk: this.canopies.filter((item) => item.model === "Kraken Low Bulk").length,
          zp: this.canopies.filter((item) => item.model === "Kraken ZP").length,
        });
      } catch {
        this.root.innerHTML =
          `<p class="kr-stock__error">${u(this.options.translations.stock.load_error)}</p>`;
        return;
      }
      this.render();
    }
    render() {
      const e = this.canopies.filter((item) => {
          const matchesSize = this.activeFilter === null || item.size === this.activeFilter;
          const matchesModel = this.activeModel === null || item.model === this.activeModel;
          return matchesSize && matchesModel;
        }),
        t = this.expanded ? e : e.slice(0, 4),
        n = e.length > 4 && !this.expanded;
      ((this.root.innerHTML = ""),
        this.root.appendChild(this.buildHeader()),
        this.root.appendChild(this.buildFilterPills()),
        this.root.appendChild(this.buildLegend()));
      if (e.length === 0) {
        const empty = document.createElement("p");
        empty.className = "kr-stock__error";
        empty.textContent = this.options.translations.stock.no_matches || "No stock canopies match these filters.";
        this.root.appendChild(empty);
        return;
      }
      const r = document.createElement("div");
      r.className = "kr-stock__grid";
      for (const o of t) r.appendChild(this.buildCard(o));
      if ((this.root.appendChild(r), n)) {
        const o = document.createElement("button");
        ((o.className = "kr-stock__show-all"),
          (o.textContent = F(this.options.translations.stock.show_all, { count: e.length })),
          o.addEventListener("click", () => {
            ((this.expanded = !0), this.render());
          }),
          this.root.appendChild(o));
      }
    }
    buildHeader() {
      const e = document.createElement("div");
      return (
        (e.className = "kr-stock__header"),
        (e.innerHTML = `
      <h2 class="kr-stock__title">${u(this.options.translations.stock.heading)}</h2>
      <span class="kr-stock__updated">${u(this.options.translations.stock.updated_daily)}</span>
    `),
        e
      );
    }
    buildFilterPills() {
      const wrapper = document.createElement("div");
      wrapper.className = "kr-stock__filter-groups";

      const modelGroup = document.createElement("div");
      modelGroup.className = "kr-stock__filter-group";
      const modelLabel = document.createElement("span");
      modelLabel.className = "kr-stock__filter-label";
      modelLabel.textContent = this.options.translations.stock.model || "Model";
      modelGroup.appendChild(modelLabel);
      const modelNav = document.createElement("nav");
      modelNav.className = "kr-stock__filters";
      modelNav.setAttribute("aria-label", this.options.translations.stock.filter_by_model || "Filter by model");
      const modelChoices = [
        { value: null, label: this.options.translations.stock.all },
        { value: "Kraken Low Bulk", label: this.options.translations.configurator.fabrics["low-bulk"] },
        { value: "Kraken ZP", label: this.options.translations.configurator.fabrics.zp },
      ];
      for (const choice of modelChoices) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "kr-stock__filter-pill";
        button.classList.toggle("kr-stock__filter-pill--active", this.activeModel === choice.value);
        button.textContent = choice.label;
        button.addEventListener("click", () => {
          this.activeModel = choice.value;
          this.expanded = !1;
          d("jyro_stock_model_filter_used", { model: choice.value || "all" });
          this.render();
        });
        modelNav.appendChild(button);
      }
      modelGroup.appendChild(modelNav);
      wrapper.appendChild(modelGroup);

      const sizeGroup = document.createElement("div");
      sizeGroup.className = "kr-stock__filter-group";
      const sizeLabel = document.createElement("span");
      sizeLabel.className = "kr-stock__filter-label";
      sizeLabel.textContent = this.options.translations.stock.size || this.options.translations.configurator.size;
      sizeGroup.appendChild(sizeLabel);
      const sizeNav = document.createElement("nav");
      sizeNav.className = "kr-stock__filters";
      sizeNav.setAttribute("aria-label", this.options.translations.stock.filter_by_size);
      const sizes = [null, ...this.options.config.sizes];
      for (const size of sizes) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "kr-stock__filter-pill";
        button.classList.toggle("kr-stock__filter-pill--active", this.activeFilter === size);
        button.textContent = size === null ? this.options.translations.stock.all : String(size);
        button.addEventListener("click", () => {
          this.activeFilter = size;
          this.expanded = !1;
          d("jyro_stock_filter_used", { size: size ?? "all" });
          this.render();
        });
        sizeNav.appendChild(button);
      }
      sizeGroup.appendChild(sizeNav);
      wrapper.appendChild(sizeGroup);
      return wrapper;
    }
    buildLegend() {
      const e = document.createElement("div");
      return (
        (e.className = "kr-stock__legend"),
        (e.innerHTML = `
      <span class="kr-stock__legend-item"><span class="kr-stock__badge kr-stock__badge--ready"></span> ${u(this.options.translations.stock.ready)}</span>
      <span class="kr-stock__legend-item"><span class="kr-stock__badge kr-stock__badge--production"></span> ${u(this.options.translations.stock.in_production)}</span>
    `),
        e
      );
    }
    buildCard(e) {
      const t = document.createElement("article");
      t.className = "kr-stock__card";
      const n = e.status === "ready" ? this.options.translations.stock.ready : this.options.translations.stock.in_production,
        r =
          e.status === "ready"
            ? "kr-stock__badge--ready"
            : "kr-stock__badge--production",
        o = e.status === "ready" ? this.options.translations.stock.add_to_cart : this.options.translations.stock.pre_order;
      let a = "";
      try {
        const model = /\bZP\b/i.test(e.model || "") ? "zp" : "low-bulk",
          i = m(this.options.config, e.size, model),
          l = new Intl.NumberFormat(this.options.locale || "en", {
            style: "currency",
            currency: this.options.currency || "EUR",
          }).format(i);
        a = `<p class="kr-stock__card-price">${u(l)}</p>`;
      } catch {}
      t.innerHTML = `
      <div class="kr-stock__card-img-wrap">
        <img class="kr-stock__card-img" src="${u(e.imageUrl)}" alt="${u(F(this.options.translations.stock.image_alt, { model: e.model, size: e.size }))}" loading="lazy" />
        <span class="kr-stock__badge ${r}">${u(n)}</span>
      </div>
      <div class="kr-stock__card-body">
        <h3 class="kr-stock__card-title">${u(e.model)} ${e.size}</h3>
        <p class="kr-stock__card-colors">${u(e.colors)}</p>
        ${a}
      </div>
    `;
      const c = document.createElement("button");
      return (
        (c.className = "kr-stock__card-cta"),
        (c.textContent = o),
        c.addEventListener("click", () => {
          const i = O(this.options.config, e);
          (d("jyro_stock_added_to_cart", {
            size: e.size,
            status: e.status,
            value: e.price / 100,
            currency: e.currency,
          }),
            this.options.onAddToCart(i));
        }),
        t.querySelector(".kr-stock__card-body").appendChild(c),
        t
      );
    }
  }
  const M = {
    brand: "JYRO",
    model: "Kraken",
    productHandle: "jyro-kraken-low-bulk",
    configVersion: "kraken-2026-10-19",
    sizes: [119, 129, 139, 149, 159, 169, 179, 189],
    zones: [
      {
        id: "topSkin",
        label: "Top Skin",
        colors: [
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "blueberry", label: "Blueberry", hex: "#3ba4d9" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
          { id: "orange", label: "Orange", hex: "#ff6600" },
          { id: "pink", label: "Pink", hex: "#ff4daa" },
          { id: "purple", label: "Purple", hex: "#7b2fbe" },
          { id: "grey", label: "Grey", hex: "#8c8c8c" },
          { id: "navy", label: "Navy", hex: "#1a2255" },
        ],
        defaultColor: "black",
        layerImage: "",
      },
      {
        id: "bottomSkin",
        label: "Bottom Skin",
        colors: [
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "blueberry", label: "Blueberry", hex: "#3ba4d9" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
          { id: "orange", label: "Orange", hex: "#ff6600" },
          { id: "pink", label: "Pink", hex: "#ff4daa" },
          { id: "purple", label: "Purple", hex: "#7b2fbe" },
          { id: "grey", label: "Grey", hex: "#8c8c8c" },
          { id: "navy", label: "Navy", hex: "#1a2255" },
        ],
        defaultColor: "white",
        layerImage: "",
      },
    ],
    lineOptionsByModel: {
      "low-bulk": ["Standard"],
      zp: ["Vectran 400", "Vectran 500", "Vectran 750"],
    },
    defaultLines: "Standard",
    defaultLinesByModel: { "low-bulk": "Standard", zp: "Vectran 400" },
    priceSignatures: [
      {
        size: 119,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515402071,
        priceEur: 3390,
      },
      {
        size: 129,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515434839,
        priceEur: 3390,
      },
      {
        size: 139,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515467607,
        priceEur: 3390,
      },
      {
        size: 149,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515500375,
        priceEur: 3390,
      },
      {
        size: 159,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515533143,
        priceEur: 3390,
      },
      {
        size: 169,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515565911,
        priceEur: 3390,
      },
      {
        size: 179,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515598679,
        priceEur: 3390,
      },
      {
        size: 189,
        lineType: "Standard",
        model: "low-bulk",
        variantId: 46812515631447,
        priceEur: 3390,
      },
      {
        size: 119,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972255063,
        priceEur: 3390,
      },
      {
        size: 119,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972287831,
        priceEur: 3390,
      },
      {
        size: 119,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972320599,
        priceEur: 3390,
      },
      {
        size: 119,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973041495,
        priceEur: 3390,
      },
      {
        size: 129,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972353367,
        priceEur: 3390,
      },
      {
        size: 129,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972386135,
        priceEur: 3390,
      },
      {
        size: 129,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972418903,
        priceEur: 3390,
      },
      {
        size: 129,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973074263,
        priceEur: 3390,
      },
      {
        size: 139,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972451671,
        priceEur: 3390,
      },
      {
        size: 139,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972484439,
        priceEur: 3390,
      },
      {
        size: 139,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972517207,
        priceEur: 3390,
      },
      {
        size: 139,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973107031,
        priceEur: 3390,
      },
      {
        size: 149,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972549975,
        priceEur: 3390,
      },
      {
        size: 149,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972582743,
        priceEur: 3390,
      },
      {
        size: 149,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972615511,
        priceEur: 3390,
      },
      {
        size: 149,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973139799,
        priceEur: 3390,
      },
      {
        size: 159,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972648279,
        priceEur: 3390,
      },
      {
        size: 159,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972681047,
        priceEur: 3390,
      },
      {
        size: 159,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972713815,
        priceEur: 3390,
      },
      {
        size: 159,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973172567,
        priceEur: 3390,
      },
      {
        size: 169,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972746583,
        priceEur: 3390,
      },
      {
        size: 169,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972779351,
        priceEur: 3390,
      },
      {
        size: 169,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972812119,
        priceEur: 3390,
      },
      {
        size: 169,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973205335,
        priceEur: 3390,
      },
      {
        size: 179,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972844887,
        priceEur: 3390,
      },
      {
        size: 179,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972877655,
        priceEur: 3390,
      },
      {
        size: 179,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509972910423,
        priceEur: 3390,
      },
      {
        size: 179,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973238103,
        priceEur: 3390,
      },
      {
        size: 189,
        lineType: "Vectran 400",
        model: "zp",
        variantId: 55509972943191,
        priceEur: 3390,
      },
      {
        size: 189,
        lineType: "Vectran 500",
        model: "zp",
        variantId: 55509972975959,
        priceEur: 3390,
      },
      {
        size: 189,
        lineType: "Vectran 750",
        model: "zp",
        variantId: 55509973008727,
        priceEur: 3390,
      },
      {
        size: 189,
        lineType: "Stock canopy",
        model: "zp",
        variantId: 55509973270871,
        priceEur: 3390,
      },
    ],
  };
  function v(s, t) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(s),
    })
      .then((e) => {
        if (!e.ok) throw new Error(`Cart error ${e.status}`);
        window.location.href = "/cart";
      })
      .catch((e) => {
        (console.error("Add to cart failed:", e),
          alert(t.cart.error));
      });
  }
  async function b() {
    const translations = await loadProductTranslations();
    const config = I(G(M, translations));
    const mounts = [];
    document.querySelectorAll("[data-kr-configurator-root]").forEach((root) => {
      const options = {
        config,
        productUrl: root.dataset.productUrl ?? window.location.href,
        locale: root.dataset.locale ?? "en",
        currency: root.dataset.currency ?? "EUR",
        assetBase: root.dataset.assetBase ?? "",
        workerBaseUrl: root.dataset.workerBaseUrl ?? "",
        translations,
        onAddToCart: (payload) => v(payload, translations),
      };
      mounts.push(new _(root, options).mount());
    });
    document.querySelectorAll("[data-kr-stock-root]").forEach((root) => {
      const apiBaseUrl = root.dataset.workerBaseUrl ?? "";
      mounts.push(new H(root, {
        config,
        apiBaseUrl,
        locale: root.dataset.locale ?? "en",
        currency: root.dataset.currency ?? "EUR",
        translations,
        onAddToCart: (payload) => v(payload, translations),
      }).mount());
    });
    await Promise.all(mounts);
    return true;
  }
  ((window.JyroKraken = { mountAll: b }),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", b)
      : b());
})();
